import BookSuggestionResource from "../../resources/book-suggestion-resource"

export const makeBookSuggestionResource = (): BookSuggestionResource => {
    return new BookSuggestionResource()
}
